import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalDropdown from '../portalDropdown';

@inject('systemLocalesStore') @observer
export default class LanguagesDropdownContainer extends Component {

    componentDidMount() {

        this.props.systemLocalesStore.getSystemLocales();
    }

    shouldComponentUpdate(nextProps) {

        if (nextProps.value !== this.props.value ||
                nextProps.errorText !== this.props.errorText ||
                nextProps.floatingLabelText !== this.props.floatingLabelText) {
            
            return true;
        }

        return false;
    }

    render() {

        if (this.props.systemLocalesStore.languages === undefined) {

            return null;
        }

        const languages = this.props.systemLocalesStore.languages.slice();

        languages.forEach(language => {
            language.text = language.displayName;
        });

        return (
            <div className='portal-languages-dropdown'>
                <PortalDropdown
                    items={languages}
                    {...this.props}
                />
            </div>
        );
    }
}